export default {
  API_URL: 'https://npgroup-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://npgroupsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
